<app-primas-table #profileHistoryFileTable (onRefresh)="refreshData($event)" [resource]="resource.table"
  [columnsTable]="columns" [tableAction]="false" [allowSelectRow]="false" [optionHeight]="'45vh'">
</app-primas-table>

<ng-template #fileNameCol let-row="row" let-rowIndex="rowIndex">
  <span *ngIf="!downloading || (downloading && selectedRowIndex !== rowIndex)"
    (click)="!downloading? downLoadFile(row,rowIndex): null" [ngClass]="'hoverable'">
    <b>{{displayFormatFileName(row.userUpload)}} </b>
  </span>
  <ng-container *ngIf="selectedRowIndex == rowIndex && downloading">
    <div fxLayout="row" fxLayoutAlign="space-between center">
      <nb-progress-bar [value]="downloadPercent" [status]="status" fxFlex="90" size="large" [displayValue]="true">
      </nb-progress-bar>
      <mat-spinner [diameter]="15" fxFlex></mat-spinner>
    </div>
  </ng-container>
</ng-template>

<div *ngIf="showBottomAction" mat-dialog-actions class="float-right">
  <button mat-button color="primary" (click)="closeDialog()">
    Close
  </button>
</div>

<ng-template #shareField let-row="row">
  <div class="status-label shared-by-me" *ngIf="referenceId === row?.userUpload?.referenceId && row?.userUpload?.shareAble">
    <mat-icon> insert_link</mat-icon>
    Shared
  </div>
  
  <div class="status-label not-shared" *ngIf="referenceId === row?.userUpload?.referenceId && !row?.userUpload?.shareAble">
    <mat-icon>lock</mat-icon>
    Not shared
  </div>
  
  <div class="status-label shared-with-me" *ngIf="referenceId !== row?.userUpload?.referenceId && row?.userUpload?.shareAble">
    <mat-icon>group</mat-icon>
    Shared with me
  </div>
</ng-template>